(function () {
  'use strict';

  angular
    .module('betosyswebapp')
    .directive('headerNav', HeaderNavComponent);

  /* @ngInject */
  function HeaderNavComponent() {
    var directive = {
      bindToController: {
        //user:'='
      },
      controller: HeaderNavController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: 'components/common/directives/header/header-nav.component.tpl.html',
      replace: true
    };
    return directive;
  }

  //HeaderUserController.$inject = ['$scope', 'AuthenticationService', '$state', '$uibModal'];

  /** @ngInject */
  function HeaderNavController($scope, $translate, $uibModal, AuthenticationService, languageService, $state, tmhDynamicLocale, $rootScope, $locale, commonTrackService, $interval, $filter, messageService, toastService, AdmStatusService, PubSubService, localStorageService, $window, errorHandlingService, userPreferenceService, widgetSettingsCreatorService) {
    $scope.isLogin = AuthenticationService.IsLogin();
    $scope.currentLanguage = languageService.getLanguageSettings().language;
    var msgDeviceChangedEvent, msgNewEvent, msgEvent, commandNewEvent;
    $translate.use($scope.currentLanguage);
    $scope.currState = $state;
    $scope.isDefaultNav = true;
    var intervalObj;
    var messageIntervalObj;
    $scope.messageList = [];
    $scope.notifictionList = [];
    $scope.glued = true;
    $scope.notoficationCount = 0;
    $scope.showChatWindowToggle = false;
    $scope.groupMessages = [];
    $scope.selectedGroup = null;
    $scope.showGroupChat = false;
    $scope.groupMsgRadio = { ackMsg: 'Ok'};
    $scope.availableGroups = [];
    $scope.filteredGroups = [];
    var groupMsgEvent, groupMsgNewEvent, groupMsgReadEvent;
    $scope.pendingGroupMessages = {};
    $scope.isGroup = false;
    $scope.groupUnreadCount = 0;
    $scope.totalUnreadCount = 0;
    $scope.deviceCache = {};
    $scope.seenGroupMessages = {};
    $scope.locallyReadGroups = {};
    $scope.groupCache = {};
    $scope.groupMessagesCache = {};

    $scope.getDeviceInfo = function(deviceIdOrObject) {
      var deviceId;
      if (typeof deviceIdOrObject === 'object' && deviceIdOrObject !== null) {
        deviceId = deviceIdOrObject.deviceId || deviceIdOrObject.deviceID;
      } else {
        deviceId = deviceIdOrObject;
      }

      if (!deviceId) {
        return null;
      }

      if ($scope.deviceCache[deviceId]) {
        return $scope.deviceCache[deviceId];
      }

      var device = null;

      if ($scope.messageList && $scope.messageList.length > 0) {
        device = $scope.messageList.find(function(msg) {
          return msg.deviceID === deviceId;
        });
      }

      if (!device && $scope.msgVehicleSettings && $scope.msgVehicleSettings.source) {
        var vehicleDevice = $scope.msgVehicleSettings.source.find(function(vehicle) {
          return vehicle.deviceID === deviceId;
        });
        if (vehicleDevice) {
          device = {
            deviceID: vehicleDevice.deviceID,
            deviceDesc: vehicleDevice.description || vehicleDevice.deviceDesc,
            driverDesc: vehicleDevice.driverDesc || vehicleDevice.description,
            deviceAvailableStatusColor: vehicleDevice.deviceAvailableStatusColor || vehicleDevice.deviceAvilableStatusColor || '#ccc',
            latestJobStatusDesc: vehicleDevice.latestJobStatusDesc || '?'
          };
        }
      }


      if (device) {
        $scope.deviceCache[deviceId] = device;
      }

      return device;
    };

    $scope.getDeviceIdFromMember = function(member) {
      if (typeof member === 'object' && member !== null) {
        // Return deviceId if available, otherwise return userId
        return member.deviceId || member.deviceID || member.userId;
      }
      return member;
    };

    $scope.getMemberDescription = function(member) {
      if (typeof member === 'object' && member !== null) {
        return member.description || '';
      }
      return '';
    };

    $scope.getDispatcherName = function(member) {
      if (!member || !member.userId || member.userId.trim() === '') {
        return 'Unknown Dispatcher';
      }
      if (member.userId === $scope.userName) {
        return ($scope.messagemodel && $scope.messagemodel.userDesc) ? $scope.messagemodel.userDesc : member.userId;
      }
      return member.userId;
    };

    $scope.syncGroupData = function() {
      $scope.groupCache = {}; // Clear cache
      return loadavailablegroups().then(function() {
        // Update selected group with latest data if it exists
        if ($scope.selectedGroup && $scope.availableGroups) {
          var updatedGroup = $scope.availableGroups.find(function(g) {
            return g.groupId === $scope.selectedGroup.groupId;
          });
          if (updatedGroup) {
            var wasShowingMembers = $scope.showGroupMembers;
            $scope.selectedGroup = updatedGroup;
            $scope.showGroupMembers = wasShowingMembers;
          }
        }
      });
    };

    $scope.selctedDeviceMessage = _restMessageHolder();
    $scope.chatparticipant = {
      filterTxt: ''
    };
    $scope.chat = {
      messageText: null
    };
    $scope.deviceCache = {};
    $scope.chatContainer = {
      alignDirection: 0, // 0 right
      isChatWindowclosed: 1
    };
    $scope.msgRadio = {
      ackMsg: 'Ok'
    };
    function _restMessageHolder() {
      return {
        deviceId: null,
        message: null,
        isNew: false,
        currentlySelectedIndex: null,
      };
    }
    $scope.$watch(function () {
      return AuthenticationService.IsLogin();
    }, function (data) {
      $scope.isLogin = data;
      if (data) {
        var localstorageSettings = commonTrackService.getGtsLocalStorageSettings();
        if (localstorageSettings && localstorageSettings.SideBarStatus && localstorageSettings.SideBarStatus.isCollapsed || !localstorageSettings || !localstorageSettings.SideBarStatus) {
          var sideBarStatus = AdmStatusService.getSideBarStatus();
          if (!sideBarStatus.isCollapsed) {
            AdmStatusService.toggleSidebar();
          }
        }
        _initListeners();
        $scope.isDefaultNav = false;
        $scope.userName = AuthenticationService.GetLoginUserName();
        saveLanguage();
        commonTrackService.initAuthdata();
        var loginID = AuthenticationService.GetLoginID();

        commonTrackService.saveGeneralSettings({
          login: {
            accountID: loginID.Account
          }
        });
        commonTrackService.updateGtsAccountSettings().then(function () {
          return commonTrackService.updateGtsUserSettings();
        }).then(function () {
          commonTrackService.setFleetServerDetails().then(function (fleetServerDetails) {
            loaddevice();
            loadavailablegroups();
            messageService.initialize();
            _getMessages();
            if (!fleetServerDetails.instantMessageEnabled) {
              _startMessageRefreshInterval(1000 * 60);
            }
          }).finally(function () {
            var portViewName = commonTrackService.getViewPortName();
            if (portViewName === 'XS' || portViewName === 'SM' || portViewName === 'MD') {
              if ($state.previous.name === 'login') {
                $state.go('trackMap');
              }

            }
            var notificationProperties = commonTrackService.getNotifications();
            $scope.notifictionList = notificationProperties.notificationList;
            if (intervalObj) {
              $interval.cancel(intervalObj);
            }
            notifyQueueDetailList();
            _startNotificationRefreshInterval();

          });
        });

      } else {
        destroyInstance();
      }
    }, true);

    $scope.userName = AuthenticationService.GetLoginUserName();

    var loaddevice = function () {
      return commonTrackService.getDeviceComboList().then(function (vehicleList) {
        $scope.msgVehicleSettings.source = vehicleList;

      });
    };

    $scope.setLang = function (langKey) {
      // You can change the language during runtime
      $translate.use(langKey);
      $scope.currentLanguage = langKey;
      $rootScope.model = { selectedLocale: langKey };
      tmhDynamicLocale.set(langKey);
      $rootScope.$locale = $locale;
      $scope.locale = $locale;
      saveLanguage();
    };

    var saveLanguage = function () {
      if (languageService.getLanguageSettings().language !== '' && languageService.getLanguageSettings().language === $scope.currentLanguage) {
        $translate.use(languageService.getLanguageSettings().language);
      } else {
        var currentLanguageSettings = languageService.getLanguageSettings();
        currentLanguageSettings.language = $rootScope.model.selectedLocale;
        languageService.saveLanguageSettings(currentLanguageSettings);
        $translate.use(languageService.getLanguageSettings().language);
      }
      commonTrackService.init();
    };

    $scope.open = function (size) {
      $uibModal.open({
        templateUrl: 'components/login/pswdChange.tpl.html',
        controller: 'passwordController',
        size: size,
        resolve: {
          errorCode: function () {
            return '';
          }
        }
      });
    };

    $scope.clickHide = function () {
      if ($scope.isLogin) {
        $('.sideMenu').toggleClass('sideMenuHide');
        $('.mainContent').toggleClass('mainContentFullWidth');
        if (angular.element('.listViewGrid').length > 0) {//judge whether the grid is initialized.
          $('.listViewGrid').jqxGrid('refresh');
        }
        if (angular.element('.listViewFilter').length > 0) {
          $('.listViewFilter').jqxComboBox('refresh');
        }
      }
    };

    $scope.logout = function () {
      _closeAllWindows();
      $state.go('logout', { reload: false });
    };


    function _closeAllWindows() {
      $scope.closeChatWindow(true);
      $scope.showChatWindowToggle = false;
      $scope.showGroupChat = false;
      $scope.selectedGroup = null;

      if (intervalObj) {
        $interval.cancel(intervalObj);
      }
      cancelExistingMessageInterval();
      intervalObj = undefined;
      messageIntervalObj = undefined;
      $scope.messageList = [];
      $scope.msgUnseenCount = 0;
      $scope.groupUnreadCount = 0;
      $scope.totalUnreadCount = 0;
      $scope.deviceCache = {};
      $scope.groupCache = {};
      $scope.groupMessagesCache = {};
      $scope.locallyReadGroups = {};
      $scope.seenGroupMessages = {};
      $scope.pendingGroupMessages = {};
      messageService.deInitialize();
      $scope.chatContainer.isChatWindowclosed = 1;
      $scope.selctedDeviceMessage = _restMessageHolder();

      // Close any open modals/dialogs
      var backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      var modals = document.querySelectorAll('.modal');
      modals.forEach(function(modal) {
        modal.style.display = 'none';
      });
    }

    $scope.$watch('currState.current.name', function (newValue) {
      if (newValue) {
        $scope.isDefaultNav = newValue === 'home' || newValue === 'login' ? true : false;
      }
    }, true);


    $scope.messagemodel = {};
    /**
     *  Get the message for initial loading and also when auto refresh.
     */
    function _getMessages() {
    loadavailablegroups();
    loaddevice();

  if ($scope.showGroupChat && $scope.selectedGroup) {
    _getGroupMessages();
    return;
  }

  if ($scope.showGroupChat) {
    return;
  }

  commonTrackService.getDriverMessages($scope.messageList, !$scope.chatContainer.isChatWindowclosed && $scope.selctedDeviceMessage.message ? $scope.selctedDeviceMessage.message.deviceID : null)
    .then(function (driverMessageProperties) {
      $scope.messagemodel = driverMessageProperties;
      $scope.msgUnseenCount = driverMessageProperties.totalUnreadMessages || 0;

      if (!$scope.chatContainer.isChatWindowclosed && $scope.selctedDeviceMessage.message) {
        $scope.messageList = driverMessageProperties.driverDevices;
        var chatDeviceMessagesFromServer = driverMessageProperties.driverDevices[_getDeviceMessageIndexByDeviceId($scope.selctedDeviceMessage.message.deviceID)].messages;
        if (chatDeviceMessagesFromServer && chatDeviceMessagesFromServer.length > 0) {
          _generateMsgHistoryView(chatDeviceMessagesFromServer.slice($scope.msgProperties.messages.length + $scope.msgProperties.ackmessages.length), false);
        }
      } else {
        $scope.messageList = driverMessageProperties.driverDevices;
      }

      $scope.totalUnreadCount = ($scope.msgUnseenCount || 0) + ($scope.groupUnreadCount || 0) + ($scope.notoficationCount || 0);

      if ($scope.totalUnreadCount > 0 && $scope.chatContainer.isChatWindowclosed) {
        toastService.showErrorToast({
          type: 'I',
          message: $translate.instant('deviceMessaging.youGOt') + $scope.totalUnreadCount + $translate.instant('deviceMessaging.newMessages')
        });
      }
    })
    .catch(function(error) {
      // Only log if it's not an abort or network issue
      if (error && error.status !== -1 && error.xhrStatus !== 'abort') {
        console.error('Error loading driver messages:', error);
      }
    })
    .finally(function () {
      // Apply the appropriate filter based on current tab
      if ($scope.showGroupChat) {
        $scope.onMessageGroupFilter();
      } else {
        $scope.onMessageDeviceFilter();
      }
    });
  }


    $scope.openCommandDialog = function (type, msg) {
      var modelDialogData = {
        type: type,
        msg: msg
      };
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'components/navbar/commands.tpl.html',
        controller: 'CommandController',
        resolve: {
          messages: function () {
            return modelDialogData;
          }
        }
      });

      modalInstance.result.then(function () {
      }, function () {
        //$log.info('Modal dismissed at: ' + new Date());
      });
    };


    $scope.notificationClick = function (index) {
      $scope.notifictionList[index]._isNotificationRead = true;
      commonTrackService.setReadNotification($scope.notifictionList[index].timestamp);
      if ($scope.notifictionList[index]._notificationType === 'status') {
        $state.go('reports.vehicleDetail', {
          'reportName': 'NotifyQueueDetail',
          'vehicleId': $scope.notifictionList[index].deviceid,
          'dateFrom': commonTrackService.getDateTime('startOfDay', 'yyyy-MM-ddTHH:mm:ss'),
          'dateTo': commonTrackService.getDateTime('present', 'yyyy-MM-ddTHH:mm:ss')
        });
      }
      $scope.notoficationCount--;
    };


    /**
     *   event listners are not initialized after login ( only initialized after page refresh ),
     *   method will  be called to initialize the event listeners  after the login
     * @private
     */
    function _initListeners() {
    msgDeviceChangedEvent = $scope.$on('msg-device-changed', function (/* event, data */) {
    // _filterDeviceSpecificMsg(data);
  });


  msgNewEvent = $scope.$on('newMsgEvent', function () {
    var LstLocationSectedData = commonTrackService.getsetLastLocatioWidgetData();
    if (LstLocationSectedData && LstLocationSectedData.selectedRow && LstLocationSectedData.selectedRow.deviceid) {
      $scope.showChatWindowToggle = true; // show the chat participant window
      // find and load the chat history for the related message
      $scope.deviceMessageClick(_getDeviceMessageIndexByDeviceId(LstLocationSectedData.selectedRow.deviceid));
      $scope.deviceMessage.deviceID = LstLocationSectedData.selectedRow.deviceid;
    }
  });

  commandNewEvent = $scope.$on('newCommandEvent', function () {
    $scope.openCommandDialog('new');
  });

  msgEvent = $scope.$on('msg-event', function (event, data) {
    data.drivermessage = data.msg;
    data.messagetimestamp = data.datetime;
    var _tmpMsgHistory = [data];
    _getMessages(_tmpMsgHistory, true);
  });

  groupMsgEvent = $scope.$on('group-msg-event', function (event, data) {
    if ($scope.showGroupChat && $scope.selectedGroup && data.groupId === $scope.selectedGroup.groupId && !$scope.chatContainer.isChatWindowclosed) {
      data._msgType = data.senderId === $scope.userName ? 'sent' : 'received';
      data._timeShortDes = $filter('date')(new Date(Number(data.messagetimestamp) * 1000), 'EEE HH:mm');

      if (data._msgType === 'sent') {
        data._messageProgress = 'sentCompleted';
      }

      $scope.groupMessages.push(data);
      // Update the cached messages for this group
      if ($scope.groupMessagesCache[data.groupId]) {
        $scope.groupMessagesCache[data.groupId].messages.push(data);
        $scope.groupMessagesCache[data.groupId].timestamp = Date.now(); // Refresh cache timestamp
      }

      // Ensure unread count is 0 for open group
      for (var j = 0; j < $scope.availableGroups.length; j++) {
        if ($scope.availableGroups[j].groupId === data.groupId) {
          $scope.availableGroups[j].unreadMessageCount = 0;
          break;
        }
      }

      $scope.$apply();
    } else {
      if (data.groupId && data.senderId !== $scope.userName) {
        delete $scope.groupMessagesCache[data.groupId];

        for (var i = 0; i < $scope.availableGroups.length; i++) {
          if ($scope.availableGroups[i].groupId === data.groupId) {
            $scope.availableGroups[i].unreadMessageCount = ($scope.availableGroups[i].unreadMessageCount || 0) + 1;
            break;
          }
        }

        var totalUnreadInEvent = 0;
        for (var g = 0; g < $scope.availableGroups.length; g++) {
          totalUnreadInEvent += $scope.availableGroups[g].unreadMessageCount || 0;
        }
        $scope.groupUnreadCount = totalUnreadInEvent;
        $scope.totalUnreadCount = ($scope.msgUnseenCount || 0) + ($scope.groupUnreadCount || 0) + ($scope.notoficationCount || 0);
      }
    }
  });

  groupMsgNewEvent = $scope.$on('newGroupMsgEvent', function (event, data) {
    if (data && data.groupId) {
      $scope.showChatWindowToggle = true;
      for (var i = 0; i < $scope.availableGroups.length; i++) {
        if ($scope.availableGroups[i].groupId === data.groupId) {
          $scope.selectGroup($scope.availableGroups[i]);
          break;
        }
      }
    }
  });

  var chatMessageWatch = $scope.$watch('selctedDeviceMessage.message', function (hasChatMessage) {

    if(hasChatMessage !== null || hasChatMessage === true){
      //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
      // send event to stop the auto refresh when chat window is opened
      $rootScope.$broadcast('chat-window-open-evt');
    }
  }, true);

  var chatWindowOpenWatch = $scope.$watch('chatContainer.isChatWindowclosed', function (isClosed) {
    cancelExistingMessageInterval();
    // chat window is open cance existing refreh interval and start new one with 5000 mili
    if (isClosed) {
      messageIntervalObj = $interval(function () {
        _getMessages();
      }, 1000 * 60);
    } else if (isClosed === 0) {
      messageIntervalObj = $interval(function () {
        _getMessages();
      }, 1000 * 5);
    }
  }, true);


  $scope.$on('$destroy', function () {
    destroyInstance();
    chatWindowOpenWatch();
    chatMessageWatch();
  });
}

    var notifyQueueDetailList = function () {
      commonTrackService.getNotificationListCurentDay().then(function (data) {
        var _ntqTmp = data.dataList;
        for (var i = 0; i < _ntqTmp.length; i++) {
          var _isFound = false;
          _ntqTmp[i]._notificationType = 'status';
          _ntqTmp[i]._dateTimeDescription = $filter('date')(new Date(), 'EEE') + _ntqTmp[i].datetime.substring(10, 16);
          for (var j = $scope.notifictionList.length - 1; j >= 0; j--) {
            if ($scope.notifictionList[j]._notificationType === 'status' && $scope.notifictionList[j].deviceid === _ntqTmp[i].deviceid && $scope.notifictionList[j].timestamp === _ntqTmp[i].timestamp) {
              _isFound = true;
              break;
            }
          }
          if (!_isFound) {
            var readNotification = commonTrackService.getFleetSettings().readNotification || [];
            var _isalreadyRead = false;
            for (var k = 0; k < readNotification.length; k++) {
              if (_ntqTmp[i].timestamp === readNotification[k]) {
                _isalreadyRead = true;
                break;
              }
            }
            if (!_isalreadyRead) {
              $scope.notifictionList.unshift(_ntqTmp[i]);
              $scope.notoficationCount++;
            }
          }
        }
      });
    };

    function _startNotificationRefreshInterval() {
      intervalObj = $interval(function () {
        notifyQueueDetailList();
      }, 1000 * 60);
    }

    function _startMessageRefreshInterval(interval) {
      cancelExistingMessageInterval();

      messageIntervalObj = $interval(function () {
        _getMessages();
      }, interval);
    }

    function destroyInstance() {
      _closeAllWindows();

      if (msgEvent) {
        msgEvent();
        msgEvent = null;
      }
      if (msgNewEvent) {
        msgNewEvent();
        msgNewEvent = null;
      }
      if (commandNewEvent) {
        commandNewEvent();
        commandNewEvent = null;
      }
      if (msgDeviceChangedEvent) {
        msgDeviceChangedEvent();
        msgDeviceChangedEvent = null;
      }
      if (groupMsgEvent) {
        groupMsgEvent();
        groupMsgEvent = null;
      }
      if (groupMsgNewEvent) {
        groupMsgNewEvent();
        groupMsgNewEvent = null;
      }
      if (groupMsgReadEvent) {
        groupMsgReadEvent();
        groupMsgReadEvent = null;
      }
      if (intervalObj) {
        $interval.cancel(intervalObj);
      }

      cancelExistingMessageInterval();

      intervalObj = undefined;
      messageIntervalObj = undefined;
      messageService.deInitialize();
    }

    PubSubService.subscribe('_TOGGLE_SIDEBAR_', function () {
      var localstorageSettings = commonTrackService.getGtsLocalStorageSettings();
      if(localstorageSettings){
        localstorageSettings.SideBarStatus = AdmStatusService.getSideBarStatus();
        var loginID = AuthenticationService.GetLoginID();
        localStorageService.set('userSettings.' + loginID.Account + '.' + loginID.username, localstorageSettings);
      }
    }, $scope);


    $scope.clearLocalStroageAndCookies = function () {
      errorHandlingService.handleForErrorNumber(52000);
    };

    /**
     *  Saves User Local Storage values to DB ,
     *  if isOnLogOut is specified it will not show if automated saving returned success .
     *  errors are shown when automated local storage saves are failed .
     * @param isOnLogOut
     */
    $scope.saveLocalStorage = function (isOnLogOut) {
      userPreferenceService.saveLocalStorage().then(function () {
        if (!isOnLogOut) {
          toastService.showSuccessToast($translate.instant('form.save.' + 'success'));
        }
      }, function (result) {
        console.log(result.data);
        errorHandlingService.handleForErrorNumber(52002);
      });
    };
    $scope.msgVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'deviceID'
    });
    $scope.restoreLocalStorage = function () {
      errorHandlingService.handleForErrorNumber(52001);
    };

    $scope.$on('errorEvent', function (event, data) {
      if (data.errorNumber === 52000 && data.type === 'yes') {
        userPreferenceService.clearLocalStroageAndCookies().then(function () {
          $window.location.reload();
        });
      }
      if (data.errorNumber === 52001 && data.type === 'yes') {
        userPreferenceService.restoreLocalStorage().then(function () {
          $window.location.reload();
        }, function (result) {
          console.log(result.data);
          errorHandlingService.handleForErrorNumber(52003);
        });
      }
    });


    $scope.msgProperties = {
      messages: []
    };

    /**
     * Executed whhen a message entry is selected fromt the chat participant window.
     * isSlected is of the pervious sleected should be set to fasle , and the new message shouls be true
     * $scope.selctedDeviceMessage should be update ( reset pervious object , populate with the selected message)
     *
     * @param {*} clickedDeviceMessageIndex
     */
    $scope.deviceMessageClick = function (clickedDeviceMessageIndex) {

      if (clickedDeviceMessageIndex !== null) {
        if ($scope.selctedDeviceMessage && $scope.selctedDeviceMessage.currentlySelectedIndex !== null) {
          $scope.messageList[$scope.selctedDeviceMessage.currentlySelectedIndex].isSlected = false;
        }
        $scope.messageList[clickedDeviceMessageIndex].isSlected = true;

        $scope.selctedDeviceMessage = _restMessageHolder();
        $scope.selctedDeviceMessage.message = $scope.messageList[clickedDeviceMessageIndex];
        $scope.selctedDeviceMessage.currentlySelectedIndex = clickedDeviceMessageIndex;
        $scope.msgProperties.messages = []; // reset previous message history data
        $scope.msgProperties.ackmessages = [];
        $scope.chatContainer.isChatWindowclosed = 0;

        if ($scope.msgUnseenCount > 0) {
          $scope.msgUnseenCount = 0;
          $scope.totalUnreadCount = ($scope.msgUnseenCount || 0) + ($scope.groupUnreadCount || 0) + ($scope.notoficationCount || 0);
        }

        _getMessages();
        _startMessageRefreshInterval(5000);

        setTimeout(() => {
          $('#send-message-input').focus();
        }, 100);
      }

    };

    $scope.applyFilter = function(filterType) {
      // Apply filter based on the tab
      if (filterType === 'device') {
        if ($scope.chatparticipant.deviceFilterTxt && $scope.chatparticipant.deviceFilterTxt !== '') {
          $scope.messageList = $scope.messagemodel.driverDevices.filter(function (message) {
            return (message.driverDesc.toLowerCase().indexOf($scope.chatparticipant.deviceFilterTxt.toLowerCase()) > -1) ||
                   (message.deviceDesc.toLowerCase().indexOf($scope.chatparticipant.deviceFilterTxt.toLowerCase()) > -1);
          });
        } else {
          $scope.messageList = $scope.messagemodel.driverDevices;
        }
      } else if (filterType === 'group') {
        if ($scope.chatparticipant.groupFilterTxt && $scope.chatparticipant.groupFilterTxt !== '') {
          $scope.filteredGroups = $scope.availableGroups.filter(function (group) {
            var groupName = (group.groupName || '').toLowerCase();
            var groupId = (group.groupId || '').toLowerCase();
            var filterText = $scope.chatparticipant.groupFilterTxt.toLowerCase();
            return (groupName.indexOf(filterText) > -1) || (groupId.indexOf(filterText) > -1);
          });
        } else {
          $scope.filteredGroups = $scope.availableGroups;
        }
      }
    };

    $scope.onMessageDeviceFilter = function () {
      $scope.applyFilter('device');
    };

    $scope.onMessageGroupFilter = function () {
      $scope.applyFilter('group');
    };

$scope.onFilterChange = function() {
  if ($scope.showGroupChat) {
    $scope.chatparticipant.groupFilterTxt = $scope.chatparticipant.filterTxt || '';
    $scope.applyFilter('group');
  } else {
    $scope.chatparticipant.deviceFilterTxt = $scope.chatparticipant.filterTxt || '';
    $scope.applyFilter('device');
  }
};


    /**
     * returns related index of the message based on the device id .
     *
     * @param {*} deviceID
     * @returns
     */
    function _getDeviceMessageIndexByDeviceId(deviceID) {

      for (var i = 0; i < $scope.messagemodel.driverDevices.length; i++) {
        if ($scope.messagemodel.driverDevices[i].deviceID === deviceID) {
          return i;
        }
      }
      return 0; // only for testing . should be replaced with -1 or null ;
    }

    // SCL-11320: Helper to get the byte size of a message string (UTF-8 encoded)
    function getMessageByteSize(str) {
        return encodeURIComponent(str).replace(/%[A-F\d]{2}/g, 'X').length;
    }

    // SCL-11320: Max message byte size that fits in the server storage after encryption
    var MAX_MESSAGE_SIZE = 319;

    /**
     * Send message to a Carpc , POST API is called and the response is used to update the overvall message count and the related chat history
     */
    $scope.sendMsg = function () {
      if ($scope.chat.messageText !== null && $scope.chat.messageText !== '') {
        if (getMessageByteSize($scope.chat.messageText) > MAX_MESSAGE_SIZE) {
          $window.alert($translate.instant('deviceMessaging.characterLimitReached'));
          return;
        }
        // should call POST API, and the response should be used to update the message count, and chat window messages

        // mock value should be replaced
        var tmpMessage = {
          drivermessage: $scope.chat.messageText,
          _msgType: 'sent',
          messagetimestamp: moment().unix(),
          _messageProgress: 'sentFailed',
        };

        $scope.isGroup = false;

        commonTrackService.saveDriverMessage($scope.selctedDeviceMessage.message.deviceID, $scope.chat.messageText, $scope.msgRadio.ackMsg, $scope.isGroup).then(function () {
          tmpMessage._messageProgress = 'sentCompleted';
        }, function () {
          tmpMessage._messageProgress = 'sentFailed';
        }).finally(function () {
          $scope.msgProperties.messages.push(tmpMessage);
        });
      }
      $scope.chat.messageText = '';
    };

    $scope.messageChanged = function () {
      var inputId = $scope.showGroupChat ? '#send-group-message-input' : '#send-message-input';
      var messageText = $(inputId).val();
      var messageLength = messageText.length;
      if (messageLength === 300) {
        $window.alert($translate.instant('deviceMessaging.characterLimitReached'));
      } else if (messageLength > 0 && getMessageByteSize(messageText) > MAX_MESSAGE_SIZE) {
        $window.alert($translate.instant('deviceMessaging.characterLimitReached'));
      }
    };

   // SCL-9873 Group messaging functions
  $scope.sendGroupMsg = function () {
  if ($scope.chat.messageText !== null && $scope.chat.messageText !== '' && $scope.selectedGroup) {
    if (getMessageByteSize($scope.chat.messageText) > MAX_MESSAGE_SIZE) {
      $window.alert($translate.instant('deviceMessaging.characterLimitReached'));
      return;
    }
    var tempId = Date.now() + '_' + Math.random();
    var tmpMessage = {
      drivermessage: $scope.chat.messageText,
      _msgType: 'sent',
      messagetimestamp: moment().unix(),
      _messageProgress: 'sentCompleted',
      _tempId: tempId,
      _timeShortDes: $filter('date')(new Date(), 'EEE HH:mm'),
      senderId: $scope.userName,
      senderDesc: $scope.messagemodel.userDesc || $scope.userName,
      _hasAckMessage: false
    };

    $scope.pendingGroupMessages[tempId] = tmpMessage;
    $scope.groupMessages.push(tmpMessage);

    if ($scope.groupMessagesCache[$scope.selectedGroup.groupId]) {
      $scope.groupMessagesCache[$scope.selectedGroup.groupId].messages.push(tmpMessage);
      $scope.groupMessagesCache[$scope.selectedGroup.groupId].timestamp = Date.now();
    }

    $scope.isGroup = true;

    commonTrackService.saveDriverMessage($scope.selectedGroup.groupId, $scope.chat.messageText, $scope.groupMsgRadio.ackMsg, $scope.isGroup).then(function () {
      tmpMessage._messageProgress = 'sentCompleted';
      var removeTimer = $interval(function() {
        delete $scope.pendingGroupMessages[tempId];
        $interval.cancel(removeTimer);
      }, 5000, 1);
    }, function () {
      tmpMessage._messageProgress = 'sentFailed';
    }).finally(function () {
      $scope.groupMessages.push(tmpMessage);
      if (!$scope.$$phase) {
        $scope.$apply();
      }
    });
  }
  $scope.chat.messageText = '';
};
  $scope.selectGroup = function(group) {
    $scope.closeChatWindow(true);
    $scope.selectedGroup = group;
    $scope.showGroupChat = true;
    $scope.chatContainer.isChatWindowclosed = 0;
    $scope.groupMessages = [];

    if (group.unreadMessageCount > 0) {
      $scope.locallyReadGroups[group.groupId] = true;

      // Update the group's unread count in the available groups list
      for (var i = 0; i < $scope.availableGroups.length; i++) {
        if ($scope.availableGroups[i].groupId === group.groupId) {
          $scope.availableGroups[i].unreadMessageCount = 0;
          break;
        }
      }

      var totalUnreadInSelect = 0;
      for (var g = 0; g < $scope.availableGroups.length; g++) {
        totalUnreadInSelect += $scope.availableGroups[g].unreadMessageCount || 0;
      }
      $scope.groupUnreadCount = totalUnreadInSelect;
      $scope.totalUnreadCount = ($scope.msgUnseenCount || 0) + ($scope.groupUnreadCount || 0) + ($scope.notoficationCount || 0);
    }

    _getGroupMessages();
    _startMessageRefreshInterval(5000);

    setTimeout(function() {
      $('#send-group-message-input').focus();
    }, 100);
  };

  $scope.switchTab = function(tabType) {
    if (tabType === 'drivers') {
      $scope.showGroupChat = false;
      $scope.selectedGroup = null;
      $scope.groupMessages = [];
      $scope.pendingGroupMessages = {};

      $scope.chatparticipant.filterTxt = $scope.chatparticipant.deviceFilterTxt || '';
      $scope.onMessageDeviceFilter();

      if (!$scope.chatContainer.isChatWindowclosed) {
        _startMessageRefreshInterval(5000);
      }
    } else if (tabType === 'groups') {
      $scope.showGroupChat = true;

      $scope.chatparticipant.filterTxt = $scope.chatparticipant.groupFilterTxt || '';
      $scope.onMessageGroupFilter();

      if ($scope.selctedDeviceMessage && $scope.selctedDeviceMessage.message) {
        $scope.closeChatWindow(true);
      }

      if ($scope.selectedGroup && !$scope.chatContainer.isChatWindowclosed) {
        _startMessageRefreshInterval(5000);
      }
    }
  };

  $scope.switchToDriversTab = function() {
    $scope.switchTab('drivers');
  };

  $scope.switchToGroupsTab = function() {
    $scope.switchTab('groups');
  };

     function loadavailablegroups() {
      if ($scope.groupCache.data && $scope.groupCache.timestamp) {
        var cacheAge = Date.now() - $scope.groupCache.timestamp;
        // Use cache if it's less than 30 seconds old
        if (cacheAge < 30000) {
          var cachedGroups = $scope.groupCache.data;
          var adjustedUnreadCount = $scope.groupCache.totalUnreadMessages || 0;

          cachedGroups.forEach(function(group) {
            if ($scope.locallyReadGroups[group.groupId]) {
              if (group.unreadMessageCount > 0) {
                adjustedUnreadCount -= group.unreadMessageCount;
                group.unreadMessageCount = 0;
              }
            }
          });

          $scope.availableGroups = cachedGroups;
          $scope.groupUnreadCount = Math.max(0, adjustedUnreadCount);

          cachedGroups.forEach(function(group) {
            if (group.unreadMessageCount === 0 && $scope.locallyReadGroups[group.groupId]) {
              delete $scope.locallyReadGroups[group.groupId];
            }
          });

          $scope.onMessageGroupFilter();
          return Promise.resolve();
        }
      }

      return commonTrackService.getAvailableGroups().then(function(response) {
        var serverGroups = response && response.groups ? response.groups : (response || []);

        // Cache the server response
        $scope.groupCache = {
          data: serverGroups.slice(),
          totalUnreadMessages: response.totalUnreadMessages || 0,
          timestamp: Date.now()
        };

        var adjustedUnreadCount = response.totalUnreadMessages || 0;

        serverGroups.forEach(function(group) {
          // If this group is currently open, force unread count to 0
          if ($scope.showGroupChat && $scope.selectedGroup && group.groupId === $scope.selectedGroup.groupId && !$scope.chatContainer.isChatWindowclosed) {
            if (group.unreadMessageCount > 0) {
              adjustedUnreadCount -= group.unreadMessageCount;
              group.unreadMessageCount = 0;
            }
          } else if ($scope.locallyReadGroups[group.groupId]) {
            if (group.unreadMessageCount > 0) {
              adjustedUnreadCount -= group.unreadMessageCount;
              group.unreadMessageCount = 0;
            }
          }
        });

        $scope.availableGroups = serverGroups;
        $scope.groupUnreadCount = Math.max(0, adjustedUnreadCount);

        serverGroups.forEach(function(group) {
          if (group.unreadMessageCount === 0 && $scope.locallyReadGroups[group.groupId]) {
            delete $scope.locallyReadGroups[group.groupId];
          }
        });

        $scope.onMessageGroupFilter();
      }, function(error) {
        console.error('Error loading available groups:', error);
        $scope.availableGroups = [];
        $scope.filteredGroups = [];
        $scope.groupUnreadCount = 0;
      });
    }

 function _getGroupMessages() {
  if ($scope.selectedGroup) {
    var groupId = $scope.selectedGroup.groupId;

    if ($scope.groupMessagesCache[groupId] && $scope.groupMessagesCache[groupId].timestamp) {
      var cacheAge = Date.now() - $scope.groupMessagesCache[groupId].timestamp;
      // Use cache if it's less than 15 seconds old
      if (cacheAge < 15000) {
        var cachedMessages = $scope.groupMessagesCache[groupId].messages;

        if (!$scope.chatContainer.isChatWindowclosed && $scope.selectedGroup) {
          // Save pending messages
          var pendingMsgs = [];
          for (var i = 0; i < $scope.groupMessages.length; i++) {
            if ($scope.groupMessages[i]._tempId && $scope.pendingGroupMessages[$scope.groupMessages[i]._tempId]) {
              pendingMsgs.push($scope.groupMessages[i]);
            }
          }

          $scope.groupMessages = [];
          _generateGroupMsgHistoryView(cachedMessages);

          // Re-add pending messages that haven't been confirmed by server
          for (var p = 0; p < pendingMsgs.length; p++) {
            var foundInServer = false;
            for (var m = 0; m < $scope.groupMessages.length; m++) {
              if (!$scope.groupMessages[m]._tempId &&
                  $scope.groupMessages[m].drivermessage === pendingMsgs[p].drivermessage &&
                  $scope.groupMessages[m]._msgType === 'sent' &&
                  Math.abs($scope.groupMessages[m].messagetimestamp - pendingMsgs[p].messagetimestamp) < 10) {
                foundInServer = true;
                break;
              }
            }
            if (!foundInServer) {
              $scope.groupMessages.push(pendingMsgs[p]);
            }
          }
        }
        // Still sync group data even when using cache
        $scope.syncGroupData();
        return;
      }
    }

    // Fetch fresh messages and sync group data
    commonTrackService.getGroupMessages($scope.groupMessages, groupId)
      .then(function(response) {
        var newMessages = [];

        if (response && response.groupConversations) {
          newMessages = response.groupConversations;
        } else if (response && Array.isArray(response)) {
          newMessages = response;
        } else {
          return;
        }

        // Sort the new messages by creationTime before processing
        newMessages.sort(function(a, b) {
          var timestampA = a.creationTime || a.messagetimestamp || 0;
          var timestampB = b.creationTime || b.messagetimestamp || 0;
          return timestampA - timestampB;
        });

        $scope.groupMessagesCache[groupId] = {
          messages: newMessages.slice(),
          timestamp: Date.now()
        };

        if (!$scope.chatContainer.isChatWindowclosed && $scope.selectedGroup) {
          // Save pending messages
          var pendingMsgs = [];
          for (var i = 0; i < $scope.groupMessages.length; i++) {
            if ($scope.groupMessages[i]._tempId && $scope.pendingGroupMessages[$scope.groupMessages[i]._tempId]) {
              pendingMsgs.push($scope.groupMessages[i]);
            }
          }

          $scope.groupMessages = [];
          _generateGroupMsgHistoryView(newMessages);

          for (var p = 0; p < pendingMsgs.length; p++) {
            var foundInServer = false;
            for (var m = 0; m < $scope.groupMessages.length; m++) {
              if (!$scope.groupMessages[m]._tempId &&
                  $scope.groupMessages[m].drivermessage === pendingMsgs[p].drivermessage &&
                  $scope.groupMessages[m]._msgType === 'sent' &&
                  Math.abs($scope.groupMessages[m].messagetimestamp - pendingMsgs[p].messagetimestamp) < 10) {
                foundInServer = true;
                break;
              }
            }
            if (!foundInServer) {
              $scope.groupMessages.push(pendingMsgs[p]);
            }
          }
        }

        // Sync group data after getting messages
        $scope.syncGroupData();
      })
      .catch(function(error) {
        console.error('Error loading group messages:', error);
      });
  }
}

function _generateGroupMsgHistoryView(messageHistory) {
  if (messageHistory.length > 0) {
    messageHistory.sort(function(a, b) {
      var timestampA = a.creationTime || a.messagetimestamp || 0;
      var timestampB = b.creationTime || b.messagetimestamp || 0;
      return timestampA - timestampB;
    });

    for (var i = 0; i < messageHistory.length; i++) {
      var msg = messageHistory[i];

      msg.drivermessage = msg.message || msg.drivermessage;
      msg.messagetimestamp = msg.creationTime || msg.sentTimestamp || msg.messagetimestamp || 0;

      msg.statuscode = msg.statuscode === 57777 ? '0xE1B1' : msg.statuscode;

      if (msg.statuscode === '0xE1B1' && msg.drivermessage.beginsWith('{')) {
        continue;
      }

      msg.senderId = msg.messageSender || msg.senderId || msg.deviceID;

      // Check if sender is a dispatcher (no deviceID)
      if (msg.messageSender && !msg.deviceID) {
        msg.senderDesc = msg.messageSender + ' (Dispatcher)'; // Add "(Dispatcher)" label
      } else {
        var deviceInfo = $scope.getDeviceInfo(msg.deviceID);
        if (deviceInfo) {
          msg.senderDesc = deviceInfo.driverDesc || deviceInfo.deviceDesc || msg.messageSender;
        } else {
          msg.senderDesc = msg.messageSender || ('Device ' + msg.deviceID);
        }
      }

      msg._msgType = msg.senderId === $scope.userName ? 'sent' : 'received';
      msg._timeShortDes = $filter('date')(new Date(Number(msg.messagetimestamp) * 1000), 'EEE HH:mm');

      if (msg._msgType === 'sent') {
        var isPending = false;
        for (var tempId in $scope.pendingGroupMessages) {
          var pendingMsg = $scope.pendingGroupMessages[tempId];
          if (pendingMsg.drivermessage === msg.drivermessage &&
              Math.abs(pendingMsg.messagetimestamp - msg.messagetimestamp) < 10) {
            msg._messageProgress = 'sentCompleted';
            delete $scope.pendingGroupMessages[tempId];
            isPending = true;
            break;
          }
        }

        if (!isPending) {
          msg._messageProgress = 'sentCompleted';
        }
      }

      msg._responses = [];

      if (msg.responses && Array.isArray(msg.responses)) {
        msg.responses.sort(function(a, b) {
          var timestampA = a.creationTime || a.messagetimestamp || 0;
          var timestampB = b.creationTime || b.messagetimestamp || 0;
          return timestampA - timestampB;
        });

        for (var r = 0; r < msg.responses.length; r++) {
          var resp = msg.responses[r];
          resp.drivermessage = resp.message || resp.drivermessage;
          resp.messagetimestamp = resp.creationTime || resp.sentTimestamp || resp.messagetimestamp || 0;

          if (resp.drivermessage.beginsWith('{read}')) {
            continue;
          }

          if (resp.messageSender && !resp.deviceID) {
            resp.senderDesc = resp.messageSender + ' (Dispatcher)'; // Add "(Dispatcher)" label
          } else {
            var respDeviceInfo = $scope.getDeviceInfo(resp.deviceID);
            if (respDeviceInfo) {
              resp.senderDesc = respDeviceInfo.driverDesc || respDeviceInfo.deviceDesc || resp.messageSender;
            } else {
              resp.senderDesc = resp.messageSender || ('Device ' + resp.deviceID);
            }
          }

          var ackType = 'Ok';
          if (resp.drivermessage.beginsWith('{')) {
            var splitedAckMessage = resp.drivermessage.split('}');
            var rawAckType = splitedAckMessage[0].replace('{', '').toLowerCase();

            switch(rawAckType) {
              case 'ok':
                ackType = 'OK';
                break;
              case 'yes':
                ackType = 'Yes';
                break;
              case 'no':
                ackType = 'No';
                break;
              default:
                ackType = rawAckType;
            }
          }

          msg._responses.push({
            ackType: ackType,
            senderDesc: resp.senderDesc,
            timestamp: resp.messagetimestamp,
            timeShortDes: $filter('date')(new Date(Number(resp.messagetimestamp) * 1000), 'EEE HH:mm')
          });
        }
      }

      $scope.groupMessages.push(msg);
      if ($scope.selectedGroup) {
        var messageId = $scope.selectedGroup.groupId + '_' + msg.messagetimestamp + '_' + msg.senderId;
        $scope.seenGroupMessages[messageId] = true;
      }
    }
  }

  if ($scope.selectedGroup && messageHistory.length > 0) {
    for (var g = 0; g < $scope.availableGroups.length; g++) {
      if ($scope.availableGroups[g].groupId === $scope.selectedGroup.groupId) {
        $scope.availableGroups[g].unreadMessageCount = 0;
        break;
      }
    }
  }
}

    /* Toggle the chat container left or right .
    */
    $scope.toggleChatContainerAlign = function () {
      $scope.chatContainer.alignDirection = !$scope.chatContainer.alignDirection;
    };

    $scope.refreshChatMessages = function() {
      loadavailablegroups();
      if ($scope.showGroupChat && $scope.selectedGroup) {
        _getGroupMessages();
      } else if (!$scope.showGroupChat) {
        _getMessages();
      }
    };

    /* Toggle the chat container left or right .
    */
    $scope.toggleChatParticipantWindow = function () {
      $scope.showChatWindowToggle = !$scope.showChatWindowToggle;
      if ($scope.showChatWindowToggle) {
    $scope.showGroupChat = false;
  }
      if (!$scope.showChatWindowToggle) {
        $scope.closeChatWindow();
        if($scope.selctedDeviceMessage && ($scope.selctedDeviceMessage.message !== null || $scope.selctedDeviceMessage.message === true)){
          //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
          // send event to stop the auto refresh when chat window is opened
          $rootScope.$broadcast('chat-window-close-evt');
        }
      } else if ($scope.selctedDeviceMessage) {
        $scope.chatContainer.isChatWindowclosed = 0;
        if($scope.selctedDeviceMessage.message !== null || $scope.selctedDeviceMessage.message === true){
          //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
          // send event to stop the auto refresh when chat window is opened
          $rootScope.$broadcast('chat-window-open-evt');
        }
      }
    };
    /* close the ChatWindow.
   */
    $scope.closeChatWindow = function (clearSelectedChat) {

      if(clearSelectedChat){
        //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
        // send event to restart the auto refresh when chat window is closed
        $rootScope.$broadcast('chat-window-close-evt');
        $scope.selctedDeviceMessage = null;
      }

      $scope.chatContainer.isChatWindowclosed = 1;
    };



    function _setAckMessage(messageHistory, updateIndex, newMessage, ackMsg) {
      messageHistory[updateIndex]._hasAckMessage = true;
      messageHistory[updateIndex]._ackMessage = ackMsg !== 'read' ? $translate.instant('deviceMessaging.' + ackMsg) : ackMsg;
      messageHistory[updateIndex]._ackMsgSender = newMessage.senderDesc;
      messageHistory[updateIndex]._ackMasgTimeShortDes = $filter('date')(new Date(Number(newMessage.messagetimestamp) * 1000), 'EEE  HH:mm');
    }

    var index = 0;
    var _pushedNewMshIndex;
    /**
     * Prepares the serve message for the UI Rendering ,
     * 1. set message type
     * 2. if ACK message move that message to the related send message block
     * @param {*} messageHistory
     * @param {*} isRefresh
     */
    function _generateMsgHistoryView(messageHistory, isRefresh) {
      if (messageHistory.length > 0) {
        for (var i = 0; i < messageHistory.length; i++) {
          messageHistory[i].statuscode = messageHistory[i].statuscode === 57777 ? '0xE1B1' : messageHistory[i].statuscode;
          if (messageHistory[i].statuscode === '0xE1B1') {

            messageHistory[i]._msgType = 'recieved';
            messageHistory[i]._timeShortDes = $filter('date')(new Date(Number(messageHistory[i].messagetimestamp) * 1000), 'EEE  HH:mm');
            if (messageHistory[i].drivermessage.beginsWith('{')) {
              var _tmpIsfound = false;
              var splitedAckMessage = messageHistory[i].drivermessage.split('}');
              if (isRefresh) {
                var _tmpSourceArray = $scope.msgProperties.messages;
                for (var k = _tmpSourceArray.length - 1; k >= 0; k--) {
                  if (_tmpSourceArray[k].statuscode !== '0xE1B1' && _tmpSourceArray[k].drivermessage === splitedAckMessage[1] && !_tmpSourceArray[k]._ackMessage) {
                    //log ack driver message
                    //console.log('Matched ack messgae "' + _tmpSourceArray[k].drivermessage + '" Status Code "' + _tmpSourceArray[k].statuscode + '"');
                    _tmpIsfound = true;
                    break;
                  }
                }
                if (_tmpIsfound) {
                  _setAckMessage(_tmpSourceArray, k, messageHistory[i], splitedAckMessage[0].replace('{', ''));
                  $scope.msgProperties.ackmessages.push(messageHistory[i]);
                }
                else {
                  $scope.msgProperties.ackmessages.push(messageHistory[i]);// push to ack to mark it already read and not to consider on next refresh
                }
              } else {
                for (var j = $scope.msgProperties.messages.length -1; j >= 0; j--) {
                  if ($scope.msgProperties.messages[j].statuscode !== '0xE1B1' && $scope.msgProperties.messages[j].drivermessage === splitedAckMessage[1] && !$scope.msgProperties.messages[j]._ackMessage) {
                    //log ack driver message
                    //console.log('Matched ack messgae "' + messageHistory[j].drivermessage + '" Status Code "' + messageHistory[j].statuscode + '"');
                    _tmpIsfound = true;
                    break;
                  }
                }
                if (_tmpIsfound) {
                  _setAckMessage($scope.msgProperties.messages, j, messageHistory[i], splitedAckMessage[0].replace('{', ''));
                  $scope.msgProperties.ackmessages.push(messageHistory[i]);
                }
                else {
                  $scope.msgProperties.ackmessages.push(messageHistory[i]);// push to ack to mark it already read and not to consider on next refresh
                }
              }
            }
            else {
              messageHistory[i]._hasAckMessage = false;
              $scope.msgProperties.messages.push(messageHistory[i]);
              index++;
            }

          }
          if (messageHistory[i].statuscode !== '0xE1B1') {

            var hasMessagealreadyinSentList = false;
            for (var s = 0; s < $scope.msgProperties.messages.length; s++) {
              if ($scope.msgProperties.messages[s]._msgType === 'sent' && $scope.msgProperties.messages[s].drivermessage === messageHistory[i].drivermessage && $scope.msgProperties.messages[s].messageid === messageHistory[i].messageid) {
                hasMessagealreadyinSentList = true;
                break;
              }
            }
            if (!hasMessagealreadyinSentList) {
              messageHistory[i]._msgType = 'sent';
              messageHistory[i]._timeShortDes = $filter('date')(new Date(Number(messageHistory[i].messagetimestamp) * 1000), 'EEE  HH:mm');
              messageHistory[i]._messageProgress = 'sentCompleted';
              if (isRefresh && _pushedNewMshIndex) {
                if ($scope.msgProperties.messages[_pushedNewMshIndex].drivermessage !== messageHistory[i].drivermessage) {
                  $scope.msgProperties.messages.push(messageHistory[i]);
                  index++;
                }
              } else {
                $scope.msgProperties.messages.push(messageHistory[i]);
                index++;
              }
            }

          }
        }
      } else {
        if ($scope.msgProperties & $scope.msgProperties.msg && $scope.msgProperties.msg.deviceid && $scope.msgProperties.msg.deviceid === $scope.deviceMessage.deviceID && !isRefresh) {
          $scope.msgProperties.messages.push($scope.selctedDeviceMessage.message);
          index++;
        }
      }
    }

    function cancelExistingMessageInterval() {
      if (messageIntervalObj) {
        try {
          $interval.cancel(messageIntervalObj);
        } catch (err) {
          console.log(err);
        }

      }
    }

  }

})();



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/header/header-nav.component.js